import { render, staticRenderFns } from "./tagConfig.vue?vue&type=template&id=5482d35b&scoped=true&"
import script from "./tagConfig.vue?vue&type=script&lang=js&"
export * from "./tagConfig.vue?vue&type=script&lang=js&"
import style0 from "./tagConfig.vue?vue&type=style&index=0&id=5482d35b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5482d35b",
  null
  
)

component.options.__file = "tagConfig.vue"
export default component.exports